import React from "react";

import { Col, Row } from "react-bootstrap";


export const RegionHeader = ({ regionName, imgBase64 }) => {

    return (
        <Row>
          <Col lg={3} md={12} sm={12} className="d-flex justify-content-center">
            <img alt="region-logo" src={imgBase64} style={{ display: "inline", width: "100px", borderRadius: "5px"}} />
          </Col>
          <Col lg={9} md={12} sm={12} >
            <h3 className="pt-5"> {regionName} Region </h3> 
            <h6 className="text-muted"> Select the province in which you will be receiving the service. </h6>
          </Col>
        </Row>
    );
};